import { LANDING_IMAGES } from "./landingImages";

export const LANDING_STATS = [
  { value: "500+", label: "Certificados Emitidos", icon: "ri-award-line" },
  { value: "16", label: "Cursos Activos", icon: "ri-book-open-line", dynamicCourses: true },
  { value: "20+", label: "Empresas Clientes", icon: "ri-building-2-line" },
  { value: "15", label: "Años de Experiencia", icon: "ri-time-line" },
];

export const LANDING_SERVICES = [
  {
    icon: "ri-graduation-cap-line",
    title: "Capacitaciones",
    description:
      "Programas de formación técnica certificada en seguridad industrial, salud ocupacional y medio ambiente para el sector Oil & Gas y heavy industry.",
    features: ["Instructores certificados", "Simulaciones prácticas", "Certificación NOM e ISO"],
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Consultorías",
    description:
      "Asesoría especializada en sistemas de gestión HSE, cumplimiento normativo, análisis de riesgos y auditorías de seguridad en instalaciones industriales.",
    features: ["Diagnóstico situacional", "Planes de acción", "Cumplimiento normativo"],
  },
  {
    icon: "ri-truck-line",
    title: "Suministros",
    description:
      "Equipos de protección personal, detectores de gases, material de rescate y kits de emergencia certificados para operaciones industriales.",
    features: ["EPP certificado", "Entrega inmediata", "Stock especializado"],
  },
];

export const LANDING_ABOUT_CHECKS = [
  "Instructores certificados internacionalmente",
  "Certificados con validez oficial NOM",
  "Infraestructura de simulación de primer nivel",
  "Metodología basada en casos reales",
];

export const LANDING_IMPACT = [
  { value: "60%", label: "Reducción de incidentes" },
  { value: "98%", label: "Tasa de aprobación" },
  { value: "12K+", label: "Trabajadores capacitados" },
  { value: "100%", label: "Cumplimiento normativo" },
];

export const LANDING_SPECIALIZATIONS = [
  { icon: "ri-gas-station-line", title: "Oil & Gas", desc: "Capacitación especializada para upstream, midstream y downstream" },
  { icon: "ri-shield-check-line", title: "Seguridad Industrial", desc: "Normas NOM, OSHA y estándares internacionales" },
  { icon: "ri-heart-pulse-line", title: "Salud Ocupacional", desc: "Prevención de riesgos y bienestar del trabajador" },
  { icon: "ri-earth-line", title: "Medio Ambiente", desc: "Gestión ambiental y cumplimiento SEMARNAT" },
  { icon: "ri-stack-line", title: "Sistemas de Calidad", desc: "ISO 9001, ISO 14001, ISO 45001" },
  { icon: "ri-user-star-line", title: "Desarrollo Personal", desc: "Liderazgo, trabajo en equipo y comunicación" },
];

export const LANDING_TESTIMONIALS = [
  {
    quote: "La capacitación de KSM transformó la cultura de seguridad en nuestra planta. Los incidentes se redujeron un 60% en el primer año.",
    name: "Ing. Roberto Hernández",
    role: "Gerente HSE, PEMEX",
    initials: "RH",
  },
  {
    quote: "El sistema de certificación con validación digital de KSM es exactamente lo que necesitábamos para cumplir con auditorías internacionales.",
    name: "Dra. María Elena Vásquez",
    role: "Directora de Calidad, Dow México",
    initials: "MV",
  },
  {
    quote: "Instructores de clase mundial, instalaciones de primer nivel y certificados con reconocimiento internacional. KSM es nuestro aliado estratégico.",
    name: "Lic. Carlos Mendieta",
    role: "Superintendente de Operaciones, Halliburton",
    initials: "CM",
  },
];

export const LANDING_CLIENTS = [
  "PEMEX", "HALLIBURTON", "BAKER HUGHES", "SCHLUMBERGER", "COTEMAR", "WEATHERFORD", "DOW",
  "EXXONMOBIL", "CHEVRON", "SHELL",
];

export const DEFAULT_NEWS = [
  {
    title: "KSM renueva certificación ISO 9001:2025",
    category: "ACTUALIZACIÓN",
    published_at: "2026-06-10T12:00:00.000Z",
    image_url: LANDING_IMAGES.news1,
  },
  {
    title: "Alianza estratégica con PEMEX para HSE",
    category: "ALIANZA",
    published_at: "2026-06-05T12:00:00.000Z",
    image_url: LANDING_IMAGES.news2,
  },
  {
    title: "Simulacro de Emergencia: 100% efectividad",
    category: "RESULTADOS",
    published_at: "2026-05-28T12:00:00.000Z",
    image_url: LANDING_IMAGES.news3,
  },
  {
    title: "Expansión de centros en Tabasco",
    category: "EXPANSIÓN",
    published_at: "2026-05-15T12:00:00.000Z",
    image_url: LANDING_IMAGES.news4,
  },
];

export function courseIcon(name: string, category: string): string {
  const n = `${name} ${category}`.toLowerCase();
  if (n.includes("h2s") || n.includes("gas")) return "ri-windy-line";
  if (n.includes("altura")) return "ri-arrow-up-line";
  if (n.includes("confinad")) return "ri-door-open-line";
  if (n.includes("primeros") || n.includes("rcp")) return "ri-heart-pulse-line";
  if (n.includes("químic") || n.includes("quimic")) return "ri-flask-line";
  return "ri-shield-check-line";
}
